import { render, staticRenderFns } from "./DetalheCampanhaEmail.vue?vue&type=template&id=b26cacce&scoped=true"
import script from "./DetalheCampanhaEmail.vue?vue&type=script&lang=js"
export * from "./DetalheCampanhaEmail.vue?vue&type=script&lang=js"
import style0 from "./DetalheCampanhaEmail.vue?vue&type=style&index=0&id=b26cacce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26cacce",
  null
  
)

export default component.exports